__turbopack_context__.v({
  "container": "NavCarousel-module-scss-module__EtbBkq__container",
  "controls": "NavCarousel-module-scss-module__EtbBkq__controls",
  "image": "NavCarousel-module-scss-module__EtbBkq__image",
  "imageContainer": "NavCarousel-module-scss-module__EtbBkq__imageContainer",
  "label": "NavCarousel-module-scss-module__EtbBkq__label",
  "labelOnly": "NavCarousel-module-scss-module__EtbBkq__labelOnly",
  "navButton": "NavCarousel-module-scss-module__EtbBkq__navButton",
  "onImage": "NavCarousel-module-scss-module__EtbBkq__onImage",
  "plain": "NavCarousel-module-scss-module__EtbBkq__plain",
  "slide": "NavCarousel-module-scss-module__EtbBkq__slide",
  "swiper": "NavCarousel-module-scss-module__EtbBkq__swiper",
  "tile": "NavCarousel-module-scss-module__EtbBkq__tile",
});
